import React from 'react'
import YumSelect, { YumSelectProps } from '../YumSelect/YumSelect'
import Autocomplete from '@material-ui/lab/Autocomplete'
import YumField from '../YumInput/YumInput'
import { t } from 'ttag'
import { SelectInputProps } from '@material-ui/core/Select/SelectInput'
import { DivisionDto } from '../../services/api.types'

import { ReactComponent as GroupActiveIcon } from '../../assets/v3/icons/group-active.svg'
import { ReactComponent as GroupInactiveIcon } from '../../assets/v3/icons/group-inactive.svg'

interface YumCountrySelectProps extends YumSelectProps {
  companyDivisions: DivisionDto[]
  required?: boolean

  onChange?: SelectInputProps['onChange']
  value?: unknown
  error?: any
  label?: any
  style?: any
  ref?: any

  startIcon?: any
  startInactiveIcon?: any

  showIcon?: boolean
  useAutocompleteSelect?: boolean
  isDuringRegistration?: boolean

  isAdmin?: boolean
  maxTeamSize?: number
  verticalPadding?: number
}

export default function YumTeamSelect({
  companyDivisions,
  required,
  value,
  showIcon,
  useAutocompleteSelect,
  disabled,
  isAdmin,
  maxTeamSize,
  isDuringRegistration,
  ...props
}: YumCountrySelectProps) {
  const { ref, verticalPadding, ...otherProps } = props

  const getOptionDisabled = (option: DivisionDto) => {
    if (isAdmin) return false
    const isLocked = option.locked
    const exceedsMaxTeamSize = !!maxTeamSize && option.members >= maxTeamSize
    return isLocked || exceedsMaxTeamSize
  }

  const getOptionLabel = (option: DivisionDto) => {
    return option.name + (maxTeamSize ? ` (${option.members}/${maxTeamSize})` : '')
  }

  return useAutocompleteSelect ? (
    <Autocomplete
      disabled={disabled}
      getOptionDisabled={getOptionDisabled}
      clearText={t`Clear`}
      closeText={t`Close`}
      openText={t`Open`}
      noOptionsText={t`No options`}
      openOnFocus
      onChange={(event, newValue) => {
        // @ts-ignore
        props.onChange?.({ target: { value: newValue?.id } }, null)
      }}
      options={companyDivisions}
      value={companyDivisions.find((d) => d.id === value) || null}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <YumField
          {...params}
          label={props.label}
          style={props.style}
          startIcon={showIcon && GroupInactiveIcon}
          //startIcon={showIcon && GroupActiveIcon}
          //startIconInactive={showIcon && GroupInactiveIcon}
          value={value}
          error={props.error}
          variant="filled"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            // This disables the browser autocomplete.
            autoComplete: 'new-password',
          }}
          fullWidth={true}
          type="text"
        />
      )}
    />
  ) : (
    <YumSelect
      disabled={disabled}
      {...otherProps}
      value={value}
      startIcon={showIcon && GroupInactiveIcon}
      //startIcon={showIcon && GroupActiveIcon}
      //startIconInactive={showIcon && GroupInactiveIcon}
      verticalPadding={verticalPadding}
    >
      {required && !isDuringRegistration && !!value ? '' : <option value="" />}
      {companyDivisions.map((division, keyIndex) => (
        <option key={keyIndex} value={division.id || ''} disabled={getOptionDisabled(division)}>
          {getOptionLabel(division)}
        </option>
      ))}
    </YumSelect>
  )
}
